var store = require("adyen/../../../store");
var checkoutPaymentOptions = require("coremh/checkout/checkoutPaymentOptions");

function assignPaymentMethodValue() {
    var adyenPaymentMethod = document.querySelector("#adyenPaymentMethodName"); // if currently selected paymentMethod contains a brand it will be part of the label ID

    /* Custom Adyen implementation SFCCR-3209 + SFCCR-4018 */
    var paymentMethodId = store.brand ? "#rb_".concat(store.selectedMethod, "_").concat(store.brand) : "#rb_".concat(store.selectedMethod);
    adyenPaymentMethod.value = document.querySelector(paymentMethodId).value;
    /* Custom Adyen implementation end */
}

function setOrderFormData(response) {
    if (response.orderNo) {
        document.querySelector("#merchantReference").value = response.orderNo;
    }

    if (response.orderToken) {
        document.querySelector("#orderToken").value = response.orderToken;
    }
}

/**
 * Makes an ajax call to the controller function PaymentFromComponent.
 * Used by certain payment methods like paypal
 */
function paymentFromComponent(data, component) {
    /* Custom Adyen implementation : Perform "Adyen-PaymentFromComponent" ajax call only if adyenPaymentMethodName is valid */
    if (document.querySelector("#adyenPaymentMethodName") && document.querySelector("#adyenPaymentMethodName").value) {
        var requestData = store.partialPaymentsOrderObj ? _objectSpread(_objectSpread({}, data), {}, {partialPaymentsOrder: store.partialPaymentsOrderObj}) : data;

        $.ajax({
            url: window.paymentFromComponentURL,
            type: "post",
            data: {
                data: JSON.stringify(requestData),
                paymentMethod: document.querySelector("#adyenPaymentMethodName").value
            },
            success: function success(response) {
                var _response$fullRespons;

                setOrderFormData(response);

                if ((_response$fullRespons = response.fullResponse) !== null && _response$fullRespons !== void 0 && _response$fullRespons.action) {
                    component.handleAction(response.fullResponse.action);
                } else if (response.isApplePay) {
                    document.querySelector("#result").value = JSON.stringify(response);
                    document.querySelector("#showConfirmationForm").submit();
                } else if (response.paymentError || response.error) {
                    component.handleError();
                }
            }
        });
    }
    /* Custom Adyen implementation end */
}

function resetPaymentMethod() {
    $("#requiredBrandCode").hide();
    $("#selectedIssuer").val("");
    $("#adyenIssuerName").val("");
    $("#dateOfBirth").val("");
    $("#telephoneNumber").val("");
    $("#gender").val("");
    $("#bankAccountOwnerName").val("");
    $("#bankAccountNumber").val("");
    $("#bankLocationId").val("");
    $(".additionalFields").hide();
}

/**
 * Changes the "display" attribute of the selected method from hidden to visible
 */
function displaySelectedMethod(type) {
    var _document$querySelect;

    // If 'type' input field is present use this as type, otherwise default to function input param
    store.selectedMethod = document.querySelector("#component_".concat(type, " .type")) ? document.querySelector("#component_".concat(type, " .type")).value : type;
    resetPaymentMethod();
    document.querySelector("button[value=\"submit-payment\"]").disabled = ["paywithgoogle", "amazonpay"].indexOf(type) > -1;
    document.querySelector("#component_".concat(type)).setAttribute("style", "display:block"); // set brand for giftcards if hidden inputfield is present

    // TO DO Show hide paypal button
    var $paypalBtnWrapper = $("#component_paypal");
    var $applePaylBtnWrapper = $("#component_applepay");
    var $nextStepBtn = $(".next-step-button");

    if (type === "paypal") {
        if ($("#billingTermsAndConditions").is(":checked")) {
            $nextStepBtn.addClass("paypal-selected");
            $paypalBtnWrapper.removeClass("d-none");
        } else {
            $paypalBtnWrapper.addClass("d-none");
        }
    } else {
        $paypalBtnWrapper.removeClass("d-none");
        $nextStepBtn.removeClass("paypal-selected");
    }

    /* Custom Adyen implementation SFCCR-4500 */
    if (type === "applepay") {
        if ($("#billingTermsAndConditions").is(":checked")) {
            $nextStepBtn.addClass("applepay-selected");
            $applePaylBtnWrapper.removeClass("d-none");
        } else {
            $applePaylBtnWrapper.addClass("d-none");
        }
    } else {
        $applePaylBtnWrapper.addClass("d-none");
        $nextStepBtn.removeClass("applepay-selected");
    }
    /* Custom Adyen implementation end */

    store.brand = (_document$querySelect = document.querySelector("#component_".concat(type, " .brand"))) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.value;
}

function displayValidationErrors() {
    store.selectedPayment.node.showValidation();
    return false;
}

var selectedMethods = {};

function doCustomValidation() {
    return store.selectedMethod in selectedMethods ? selectedMethods[store.selectedMethod]() : true;
}

function showValidation() {
    return store.selectedPaymentIsValid ? doCustomValidation() : displayValidationErrors();
}

function getInstallmentValues(maxValue) {
    var values = [];

    for (var i = 1; i <= maxValue; i += 1) {
        values.push(i);
    }

    return values;
}

function createShowConfirmationForm(action) {
    if (document.querySelector("#showConfirmationForm")) {
        return;
    }

    var template = document.createElement("template");
    var form = "<form method=\"post\" id=\"showConfirmationForm\" name=\"showConfirmationForm\" action=\"".concat(action, "\">\n    <input type=\"hidden\" id=\"additionalDetailsHidden\" name=\"additionalDetailsHidden\" value=\"null\"/>\n    <input type=\"hidden\" id=\"merchantReference\" name=\"merchantReference\"/>\n    <input type=\"hidden\" id=\"orderToken\" name=\"orderToken\"/>\n    <input type=\"hidden\" id=\"result\" name=\"result\" value=\"null\"/>\n  </form>");
    template.innerHTML = form;
    document.querySelector("body").appendChild(template.content);
}

/**
 * Shows loader and disable Pay button
 */
function disablePaypalBtn() {
    $.spinner().start();
    $(".submit-payment").addClass("disabled");
    $("#component_paypal").addClass("d-none");
}

/**
* Stop loader and enable Pay button
*/
function enablePaypalBtn() {
    $.spinner().stop();
    $(".submit-payment").removeClass("disabled");
    $("#component_paypal").removeClass("d-none");
}

/**
 * Add order for Adyen payment methods to sort them based on values set in BM for each payment method
 * @param {Object} paymentWrapper - selector for payment method wrapper
 */
function setPaymentPosition(paymentWrapper) {
    var breakpoint = getBreakpoint();

    if (paymentWrapper.length) {
        paymentWrapper.each(function () {
            var $this = $(this);
            var position = $this.data("position-" + breakpoint);

            if (position) {
                $this.css("order", position);
            }
        });
    }
}

/**
 * Return object for first Adyen payment method based on configs in BM
 * @param {Object} breakpoint - selector for Adyen payment method wrappers
 * @param {String} breakpoint - breakpoint short name
 * @returns {Object} payment method wrapper object
 */
function getFirstAdyenPayment() {
    var breakpoint = getBreakpoint();

    var $adyenWrapper = $(".adyen-wrapper");
    var sortingRule = $adyenWrapper.data("sorting-rule");
    var $firstPaymentWrapper = $adyenWrapper.find(".paymentMethod[data-position-"+ breakpoint + "=\"1\"]");
    var sortingRuleLength = sortingRule !== null ? Object.keys(sortingRule).length : 0;

    for (var i = 1; i <= sortingRuleLength; i++) {
        $firstPaymentWrapper = $adyenWrapper.find(".paymentMethod[data-position-"+ breakpoint + "=" + i + "]");

        if ($firstPaymentWrapper.length) {
            return $firstPaymentWrapper;
        }
    }

    return $firstPaymentWrapper;
}

/**
 * @description Returns (bootstrap) breakpoint class
 * @returns {string}
 */
function getBreakpoint() {
    return $(window).width() > 768 ? "lg" : "sm";
}

/**
 * @description Custom Adyen implementation SFCCR-662 > Selects first payment method by default
 * @returns void
 */
function selectFirstPayment() {
    var breakpoint = getBreakpoint();
    var $paymentMethodWrappers = $(".payment-option-wrapper");
    var $paymentMethodNoSorting = $(".payment-option-wrapper[data-position-" + breakpoint + "=\"\"]");
    var $paymentMethodsWrapper = $(".core-methods");
    var $selectedPaymentOptions = $("#selectedPaymentOption");
    var $adyenWrapper = $(".adyen-wrapper");
    var $firstPayment;
    var $firstPaymentInput;

    if ($paymentMethodNoSorting.length) {
        $firstPayment = $paymentMethodNoSorting.first();

        if ($firstPayment.hasClass("adyen") && $paymentMethodNoSorting.eq(1).length) {
            $firstPayment = $paymentMethodNoSorting.eq(1);
        }
    } else {
        $firstPayment = getFirstPayment($paymentMethodWrappers, breakpoint);
    }

    if ($firstPayment) {
        if ($firstPayment.hasClass("adyen")) {
            /* Custom Adyen implementation SFCCR-1105 */
            var $firstPaymentWrapper = getFirstAdyenPayment(breakpoint);
            /* Custom Adyen implementation end */

            $firstPaymentInput = $firstPaymentWrapper.length ?  $firstPaymentWrapper.find("input[type=radio][name=brandCode]") : $adyenWrapper.find("input[type=radio][name=brandCode]").first();
            $firstPaymentInput.eq(0).prop("checked", true);
            $firstPaymentInput.parents(".paymentMethod").find(".additionalFields").show();
            $paymentMethodsWrapper.attr("data-payment-method-name", "");
            /* Custom Adyen implementation SFCCR-3375 */
            $selectedPaymentOptions.val(checkoutPaymentOptions.getSelectedValue($firstPaymentInput));
            /* Custom Adyen implementation end */
            displaySelectedMethod($firstPaymentInput.val());
        } else {
            $firstPaymentInput = $firstPayment.find("input[type=radio][name=brandCode]");
            $firstPaymentInput.prop("checked", true);
            $selectedPaymentOptions.val($firstPaymentInput.val());
            $paymentMethodsWrapper.attr("data-payment-method-name", "otherPayment");
        }
    }
}

/**
 * @description Custom Adyen implementation SFCCR-1105 > Returns object for first payment method
 * @param {Object} breakpoint - selector for payment method wrappers
 * @param {String} breakpoint - breakpoint short name
 * @returns {Object|Null} payment method wrapper object or null
 */
function getFirstPayment(paymentMethodWrappers, breakpoint) {
    var $firstPayment = null;

    for (var i = 1; i <= paymentMethodWrappers.length; i++) {
        $firstPayment = $(".payment-option-wrapper[data-position-" + breakpoint + "=" + i + "]");

        if ($firstPayment.length) {
            return $firstPayment.eq(0);
        }
    }

    /* Custom Adyen implementation SFCCR-1105 */
    if (!$firstPayment.length) {
        return $(".payment-option-wrapper").eq(0);
    }
    /* Custom Adyen implementation end */

    return $firstPayment;
}

/**
 * Custom Adyen implementation SFCCR-3086 + SFCCR-3479
 * Expands billing address form in case of error(s) related to its fields
 * @param {object} error - error object
 */
function openBillingForm(error) {
    if (error) {
        const isBillingError = Object.keys(error).some(e => e.includes("dwfrm_billing_addressFields_"));
        if (isBillingError) {
            const $checkoutMain = $("#checkout-main");
            const $billingAddressBlock = $(".billing-address-block");
            const checkoutState = $checkoutMain.attr("data-checkout-stage");
            const $btnShowDetails = $(".address-selector-block .btn-show-details");

            if ($billingAddressBlock.hasClass("d-none")) {
                const $showBillingAddress = $("#show-billing-address");

                if ($showBillingAddress.is(":checked")) {
                    $showBillingAddress.trigger("click");
                }

                $billingAddressBlock.find(".btn-show-details").trigger("click");
            } else if ($btnShowDetails.length) {
                $btnShowDetails.trigger("click");
            }

            if (checkoutState !== "payment") {
                $checkoutMain
                    .attr("data-checkout-stage", "payment")
                    .data("checkout-stage", "payment")
                    .checkout();
            }
        }
    }
}

/* Custom Adyen implementation SFCCR-4500 */
/**
* Checks if the device is an iOS device
* @returns {boolean} - true if the device is an iOS device
*/
function isIOSDevice() {
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var isIphoneOrMac = navigator.platform.includes("iPhone") || navigator.platform.includes("Mac");

    return isSafari && isIphoneOrMac;
}
/* Custom Adyen implementation end */

/**
* Custom Adyen implementation SFCCR-4880
*/

/**
* Validates if Apple Pay terms and conditions are checked before proceeding with payment
* @param {object} applePayCTA - the Apple Pay CTA element
*/
function validateApplePayTermsChecked(applePayCTA) {
    let $applePayConditions = $("#accept-apple-pay-conditions");
    let $applePayConditionsError = $("#billingTermsAndConditions-error");

    applePayCTA.addEventListener("click", function(event) {
        if (!$applePayConditions.is(":checked")) {
            $applePayConditionsError.addClass("show");

            event.preventDefault();
            event.stopPropagation();
        } else {
            $applePayConditionsError.removeClass("show");
        }
    }, true);
}

/**
* Sets an event listener for the Apple Pay Express Checkout CTA
* to display the Apple Pay terms and conditions and to validate
* the checkbox when the CTA is clicked.
*/
function setApplePayExpressCheckoutCTAEvent() {
    let observer = new MutationObserver(function(mutationsList) {
        for (let i = 0; i < mutationsList.length; i++) {
            let mutation = mutationsList[i];

            if (mutation.type === "childList") {
                for (let j = 0; j < mutation.addedNodes.length; j++) {
                    let applePayCTA = mutation.addedNodes[j];
                    /* Custom Adyen implementation GEC-924 Begin */
                    if (applePayCTA && applePayCTA.classList && applePayCTA.classList.contains("adyen-checkout__applepay__button") && $(".cart-page-maincontent").length) {
                    /* Custom Adyen implementation GEC-924 End */
                        let $applePayConditionsWrapper = $(".apple-pay-conditions");

                        $applePayConditionsWrapper.addClass("show");

                        validateApplePayTermsChecked(applePayCTA);

                        observer.disconnect();
                    }
                }
            }
        }
    });

    let observerOptions = {
        childList: true,
        subtree: true
    };

    let targetNode = document.body;

    observer.observe(targetNode, observerOptions);
}
/* Custom Adyen implementation end */

/* Custom Adyen implementation GEC-5 */
/**
 * @description Creating images based on the payment method images url
 * @param {Array} imagesPath - Payment method images url
 */
function getPaymentMethodImages(imagesPath) {
    var paymentImages = "";
    imagesPath.forEach(imagePath => {
        var imageName = imagePath?.substring(imagePath.lastIndexOf("/") + 1, imagePath.lastIndexOf("."));
        paymentImages = paymentImages.concat("<img class=\"paymentMethod_img\" alt=\"").concat(imageName, "\" src=\"").concat(imagePath, "\" ></img>\n");
    });
    return paymentImages;
}
/* Custom Adyen implementation end */

/* Custom Adyen implementation GEC-604 */
/**
* Creates a session by making an asynchronous AJAX request to the server.
* @returns {Promise} A promise that resolves with the response from the AJAX request.
*/
async function createSession() {
    var url = "Adyen-Sessions";
    var urlParams = {};
    
    const $pdpQuantitySelector = $(".quantity-select.pdp-select");
    
    if ($pdpQuantitySelector.length) {
        urlParams = { quantity: $pdpQuantitySelector.val() };
        url = appendToUrl(url, urlParams);
    }

    if (window.applePayProductId) {
        urlParams = { pid: window.applePayProductId };
        url = appendToUrl(url, urlParams);
    }

    if ($("#personalizationModal").is(":visible")) {
        var $currentBtn = $("#personalizationModal").find(".personalization-add-btn");
        var payload = {
            message: $("#personalization-form-message").val().toUpperCase()
        };
 
        var options = JSON.stringify([{
            optionId: $currentBtn.data("option-id"),
            selectedValueId: $currentBtn.data("value-id"),
            actionName: $currentBtn.data("personalization-cbt-action-name"),
            payload: payload
        }]);
 
        urlParams = { options: options };
        url = appendToUrl(url, urlParams);
    }

    return $.ajax({
        url: url,
        type: "post",
        data: $("#adyen-sessions-token").serialize()
    });
};
/* Custom Adyen implementation end */

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf("?") !== -1 ? "&" : "?") + Object.keys(params).map(function (key) {
        return key + "=" + encodeURIComponent(params[key]);
    }).join("&");

    return newUrl;
}

/**
* Mounts Apple Pay buttons into all containers matching the specified class.
* @param {Object} applePayButtonConfig - Configuration object for creating the Apple Pay button.
* @param {Function} createApplePayButton - Asynchronous function that returns a Promise resolving to an Apple Pay button instance.
* @param {string} containerClass - The class name of the container elements where Apple Pay buttons should be mounted.
*/
function mountApplePayButtons(applePayButtonConfig, createApplePayButton, containerClass) {
  var cartContainer = document.getElementsByClassName(containerClass);
  var _loop = function _loop(expressCheckoutNodesIndex) {
    createApplePayButton(applePayButtonConfig).then(function (applePayButton) {
      var isApplePayButtonAvailable = applePayButton.isAvailable();
      if (isApplePayButtonAvailable) {
        applePayButton.mount(cartContainer[expressCheckoutNodesIndex]);
        $(".express-container").removeClass("hidden");
      }
    });
  };

  for (var expressCheckoutNodesIndex = 0; expressCheckoutNodesIndex < cartContainer.length; expressCheckoutNodesIndex += 1) {
    _loop(expressCheckoutNodesIndex);
  }
}

/**
* Sets up a MutationObserver to detect and handle the addition of the Apple Pay Express button
* on the Product Detail Page (PDP) within a personalization modal. 
*/
function setApplePayExpressPDPEvent() {
    let observer = new MutationObserver(function(mutationsList) {
        for (let i = 0; i < mutationsList.length; i++) {
            let mutation = mutationsList[i];

            if (mutation.type === "childList") {
                for (let j = 0; j < mutation.addedNodes.length; j++) {
                    let applePayCTA = mutation.addedNodes[j];

                    if (applePayCTA && applePayCTA.classList && applePayCTA.classList.contains("adyen-checkout__applepay__button") && document.querySelectorAll(".product-detail").length > 0 &&
  applePayCTA.closest("#personalizationModal")) {

                        validateApplePayPersonalization(applePayCTA);

                        observer.disconnect();
                    }
                }
            }
        }
    });

    let observerOptions = {
        childList: true,
        subtree: true
    };

    let targetNode = document.body;

    observer.observe(targetNode, observerOptions);
}

/**
 * Validates the Apple Pay personalization form and shows errors if any.
 * @param {HTMLElement} applePayCTA - The Apple Pay CTA element.
 */
function validateApplePayPersonalization (applePayCTA) {
    applePayCTA.addEventListener("click", function(event) {
        const personalizationModal = document.querySelector("#personalizationModal");
        const personalizationForm = personalizationModal.querySelector("form");
        
        personalizationToUpperCase(["#personalization-form-city", "#personalization-form-message"]);

        const formInputs = Array.from(personalizationForm.querySelectorAll(".form-group input, .form-group textarea"));
        const isFormInvalid = formInputs.some(field => !field.value.length || !field.validity.valid);
    
        if (isFormInvalid) {
            event.preventDefault();
            event.stopPropagation();
        }

        validateFormInputs(formInputs);
    }, true);
}

/**
 * Displays validation errors for form inputs.
 * @param {Array} formInputs - Array of form input elements.
 */
function validateFormInputs(formInputs) {
    formInputs.forEach(field => {
        const isFieldInvalid = !field.value.length || !field.validity.valid;
        const fieldErrorMsg = field.dataset.errorMessage;
        const formGroup = field.closest(".form-group");
        formGroup.classList.toggle("is-invalid", isFieldInvalid);
        const invalidFeedback = formGroup.querySelector(".invalid-feedback");
        if (invalidFeedback) {
            invalidFeedback.innerHTML = fieldErrorMsg || '';
        }
    });
}

/**
 * Converts the value of specified form inputs to uppercase.
 * @param {Array} inputSelectors - An array of CSS selectors for the input elements.
 */
function personalizationToUpperCase(inputSelectors) {
    inputSelectors.forEach(selector => {
        const inputElement = document.querySelector(selector);
        if (inputElement) {
            inputElement.value = inputElement.value.toUpperCase();
        }
    });
}

module.exports = {
    setOrderFormData: setOrderFormData,
    assignPaymentMethodValue: assignPaymentMethodValue,
    paymentFromComponent: paymentFromComponent,
    resetPaymentMethod: resetPaymentMethod,
    displaySelectedMethod: displaySelectedMethod,
    showValidation: showValidation,
    createShowConfirmationForm: createShowConfirmationForm,
    getInstallmentValues: getInstallmentValues,
    disablePaypalBtn: disablePaypalBtn,
    enablePaypalBtn: enablePaypalBtn,
    setPaymentPosition: setPaymentPosition,
    getFirstAdyenPayment: getFirstAdyenPayment,
    selectFirstPayment: selectFirstPayment,
    openBillingForm: openBillingForm,
    isIOSDevice: isIOSDevice,
    setApplePayExpressCheckoutCTAEvent: setApplePayExpressCheckoutCTAEvent,
    getPaymentMethodImages: getPaymentMethodImages,
    createSession: createSession,
    mountApplePayButtons: mountApplePayButtons,
    setApplePayExpressPDPEvent: setApplePayExpressPDPEvent
};
